export default function ActionButton({ onClick, variant = "simulate", children, style }) {
  return (
    <button className={`PhaseBtn action-btn ${variant}`} onClick={onClick} style={style}>
      {children}
    </button>
  );
}